import React from 'react';
import { motion } from 'framer-motion';
import { PlayCircle } from 'lucide-react';
export function VideoPreview() {
  return <section className="py-12 px-4 bg-white relative overflow-hidden" data-id="element-407">
      <div className="max-w-4xl mx-auto" data-id="element-408">
        <div className="text-center mb-8" data-id="element-409">
          <div className="inline-flex items-center gap-2 bg-medical-blue/10 text-medical-blue font-bold px-4 py-1.5 rounded-full text-xs mb-3 tracking-widest" data-id="element-410">
            <PlayCircle size={14} data-id="element-411" />
            VISTA PREVIA
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-extrabold text-gray-900 mb-2" data-id="element-412">
            Explorá el interior del Atlas
          </h2>
          <p className="text-sm md:text-base text-gray-600 font-medium" data-id="element-413">
            Conocé la calidad visual de nuestros algoritmos y diagramas antes de
            tu primera guardia.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.5
      }} className="relative mx-auto max-w-3xl" data-id="element-414">
          {/* Decorative background glow */}
          <div className="absolute inset-0 bg-medical-blue/20 blur-3xl rounded-[2rem] transform scale-95 translate-y-4" data-id="element-415"></div>

          {/* Video Frame */}
          <div className="relative bg-white p-2 md:p-3 rounded-[1.5rem] md:rounded-[2rem] shadow-2xl border border-gray-100" data-id="element-416">
            <div className="overflow-hidden rounded-[1rem] md:rounded-[1.5rem] bg-gray-100 relative aspect-[9/16] sm:aspect-video" data-id="element-417">
              <video src="https://cdn.magicpatterns.com/uploads/1dK8QyWwo1sjMqtLn6BbJC/Screen record web.mov" className="w-full h-full object-cover" autoPlay loop muted playsInline data-id="element-418" />
              {/* Subtle overlay gradient to make it look like a screen */}
              <div className="absolute inset-0 bg-gradient-to-tr from-black/5 via-transparent to-white/10 pointer-events-none" data-id="element-419"></div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}